import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import RightRip from "../../../../assets/images/rip/right_rip_stroked.svg?react";
import LeftRip from "../../../../assets/images/rip/left_rip_stroked.svg?react";

export default function PaperRip({ isUsed = false, isExpired = false }: { isUsed?: boolean; isExpired?: boolean }) {
  const boxElement = useRef<Element>(null);
  const leftRipElement = useRef<SVGSVGElement>(null);
  const [height, setHeight] = useState(10);
  const [width, setWidth] = useState(10);

  useEffect(() => {
    if (boxElement.current) {
      const rect = boxElement.current.parentElement?.getBoundingClientRect();
      if (rect) {
        setHeight(rect.height);
        setWidth(rect.width);
      }
    }
  }, []);

  const translateRightRip = 1;

  const [leftRipWidth, setLeftRipWidth] = useState(10);

  useEffect(() => {
    setTimeout(() => {
      console.log(leftRipElement.current);
      if (leftRipElement.current) {
        const rect = leftRipElement.current.getBoundingClientRect();
        console.log(rect);
        if (rect) {
          setLeftRipWidth(rect.width);
        }
      }
    }, 1);
  }, [width, height]);

  return (
    <>
      <Box sx={{ position: "absolute", width: 1, height: 1, background: "#00000050" }} ref={boxElement}></Box>
      <LeftRip
        className={"JS-PaperRip-LeftRip"}
        style={{
          position: "absolute",
          left: "50%",
          transform: `translate(-${translateRightRip}px, -1px)`,

          height: "calc(100% + 2px)",
        }}
      />
      <RightRip
        ref={leftRipElement}
        className={"JS-PaperRip-RightRip"}
        style={{
          position: "absolute",
          left: "50%",
          transform: `translate(-${leftRipWidth}px, -1px)`,

          height: "calc(100% + 2px)",
        }}
      />
      <Typography
        sx={{
          transform: "rotate(10deg) translate(-50%,-50%)",
          fontWeight: 800,
          fontSize: "2.0rem",
          position: "absolute",
          left: "50%",
          top: "50%",
          color: "red",
          border: "red 1px solid",
        }}
      >
        {isUsed ? "USED" : null}
        {isExpired ? "EXPIRED" : null}
      </Typography>
    </>
  );
}
